import { FileMessage } from 'models/twilio';

const isSupportedImage = (file: FileMessage | File | undefined) => file?.type?.startsWith('image/');

export default isSupportedImage;
